import React from "react";
import PropTypes from "prop-types";
import { Input } from "antd";
import cx from "classnames";

import "styles/search-filter.css";

const Component = ({
    setSelectedKeys,
    selectedKeys = [
        {
            min: null,
            max: null
        }
    ],
    confirm,
    filterOverrideClassName
}) => {
    let minInput = null,
        maxInput = null;
    return (
        <div
            className={cx("custom-filter-dropdown", filterOverrideClassName)}
            onFocus={e => e.stopPropagation()}
        >
            <Input
                ref={node => (minInput = node)}
                placeholder={"Start (DD/MM/YYYY)"}
                value={selectedKeys[0] ? selectedKeys[0].min : null}
                onClick={e => {
                    e.stopPropagation();
                    minInput.focus();
                }}
                onChange={e =>
                    setSelectedKeys([
                        {
                            max: selectedKeys[0] ? selectedKeys[0].max : null,
                            min: e.target.value
                        }
                    ])
                }
                onPressEnter={confirm}
                onBlur={confirm}
            />
            <Input
                ref={node => (maxInput = node)}
                placeholder={"End (DD/MM/YYYY)"}
                value={selectedKeys[0] ? selectedKeys[0].max : null}
                onClick={e => {
                    e.stopPropagation();
                    maxInput.focus();
                }}
                onChange={e => {
                    setSelectedKeys([
                        {
                            min: selectedKeys[0] ? selectedKeys[0].min : null,
                            max: e.target.value
                        }
                    ]);
                }}
                onPressEnter={confirm}
                onBlur={confirm}
            />
        </div>
    );
};
Component.displayName = "TableDateFilterDropdown";
Component.propTypes = {
    setSelectedKeys: PropTypes.func,
    confirm: PropTypes.func,
    clearFilters: PropTypes.func,
    selectedKeys: PropTypes.any,
    filterOverrideClassName: PropTypes.string
};
export default Component;
